var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0048 6.30113C12.632 5.92834 12.4457 5.74194 12.3758 5.527C12.3144 5.33794 12.3144 5.13428 12.3758 4.94521C12.4457 4.73027 12.632 4.54388 13.0048 4.17108L15.6768 1.49916C14.9677 1.1785 14.1806 1 13.3519 1C10.2325 1 7.70371 3.52876 7.70371 6.64815C7.70371 7.11039 7.75924 7.55966 7.86399 7.98966C7.97616 8.45013 8.03224 8.68036 8.02229 8.82581C8.01186 8.97809 7.98916 9.05911 7.91893 9.19463C7.85186 9.32407 7.72334 9.45258 7.46632 9.70961L1.58488 15.591C0.805038 16.3709 0.805039 17.6353 1.58488 18.4151C2.36473 19.195 3.62911 19.195 4.40896 18.4151L10.2904 12.5337C10.5474 12.2767 10.6759 12.1481 10.8054 12.0811C10.9409 12.0108 11.0219 11.9881 11.1742 11.9777C11.3196 11.9678 11.5499 12.0238 12.0103 12.136C12.4403 12.2408 12.8896 12.2963 13.3519 12.2963C16.4712 12.2963 19 9.76753 19 6.64815C19 5.81937 18.8215 5.03228 18.5008 4.32323L15.8289 6.99516C15.4561 7.36795 15.2697 7.55435 15.0548 7.62419C14.8657 7.68562 14.6621 7.68562 14.473 7.62419C14.2581 7.55435 14.0717 7.36795 13.6989 6.99516L13.0048 6.30113Z",
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.2c5cc3d29c1b39a00510baacff19f50c.svg";
export { ForwardRef as ReactComponent };